// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EJlC","index":"styles_index__2o97Q"};